export default "__VITE_ASSET__XkVGLc97__"